import React from "react";
import { Body1Strong, Divider, Image, Label, SwitchOnChangeData } from "@fluentui/react-components";
import { useStyles } from "./PaymentsStyles";
import { PaymentType, useAppStore } from "../../../common";
import applePayIcon from "../../../images/apple-pay-icon.png";
import { PaymentOption } from "./PaymentOption";
import { CardForm } from "../CardForm";

type PaymentsProps = {
  disabled?: boolean;
  selected: PaymentType;
  onSelect: (paymentType: PaymentType, data: SwitchOnChangeData) => void;
};

export const Payments = ({ disabled, selected, onSelect }: PaymentsProps) => {
  const styles = useStyles();
  const [applePayEnabled] = useAppStore((state) => [state.applePayEnabled]);
  return (
    <div data-testid={"Payments"} className={styles.container}>
      <Body1Strong className={styles.header}>Payment</Body1Strong>
      <div className={styles.main}>
        {applePayEnabled && (
          <PaymentOption
            disabled={disabled}
            label={
              <Label htmlFor="ApplePay">
                <Image alt="Pay with Apple Pay" src={applePayIcon} />
              </Label>
            }
            paymentType={"ApplePay"}
            selected={selected === "ApplePay"}
            onSelect={onSelect}
          />
        )}
        {applePayEnabled && <Divider />}
        <PaymentOption
          disabled={disabled}
          label={<Label htmlFor="Card">Pay with Credit or Debit Card</Label>}
          paymentType={"Card"}
          selected={selected === "Card"}
          onSelect={onSelect}
        >
          <CardForm />
        </PaymentOption>
      </div>
    </div>
  );
};
